import { combineReducers } from "redux-immutable";

import CourseEnrollmentsStateSlice from "../models/CourseEnrollmentsStateSlice";
import enrollments from "./courseEnrollments";
import courseEnrollmentsCrudStateReducer from "./meta";

export default combineReducers(
  {
    enrollments,
    meta: courseEnrollmentsCrudStateReducer
  },
  () => new CourseEnrollmentsStateSlice() as any
);
